import { loadScript } from '@fastcampus/browser-util';

export const createKakaoSdkScript = (kakao) => {
  loadScript('https://developers.kakao.com/sdk/js/kakao.js', { async: true }).then(() => {
    try {
      kakao.init();
    } catch (err) {
      return;
    }
  });
};

export const createChannelTalkScript = (pluginKey) => {
  const w = window;
  const existChannelIOScript = document.head.querySelector(
    'script[src="https://cdn.channel.io/plugin/ch-plugin-web.js"]'
  );
  if (w.ChannelIO || existChannelIOScript) {
    return (w.console.info || w.console.log || function () {})('ChannelIO script included twice.');
  }
  const ch = (...args) => {
    ch.c(args);
  };
  ch.q = [];
  ch.c = (args) => {
    ch.q.push(args);
  };
  w.ChannelIO = ch;

  if (w.ChannelIOInitialized) {
    return;
  }
  w.ChannelIOInitialized = true;
  loadScript('https://cdn.channel.io/plugin/ch-plugin-web.js', { async: true }).then(() => {
    w.ChannelIO('boot', {
      pluginKey,
    });
  });
};

export const createGoogleChartsScript = () => {
  return loadScript('https://www.gstatic.com/charts/loader.js', { async: true });
};
